export default {
  CREATE_CUSTOMER_INVESTOR_GOAL_REMINDER_COMMAND: Symbol.for('CREATE_CUSTOMER_INVESTOR_GOAL_REMINDER_COMMAND'),
  UPDATE_CUSTOMER_INVESTOR_GOAL_REMINDER_COMMAND: Symbol.for('UPDATE_CUSTOMER_INVESTOR_GOAL_REMINDER_COMMAND'),
  GET_CUSTOMER_INVESTOR_GOAL_REMINDER_QUERY: Symbol.for('GET_CUSTOMER_INVESTOR_GOAL_REMINDER_QUERY'),
  CUSTOMER_INVESTOR_GOAL_REMINDER_REPOSITORY: Symbol.for('CUSTOMER_INVESTOR_GOAL_REMINDER_REPOSITORY'),
  CUSTOMER_INVESTOR_GOAL_REMINDER_STATE_MANAGER: Symbol.for('CUSTOMER_INVESTOR_GOAL_REMINDER_STATE_MANAGER'),
};
